import TestimonialSlide from './TestimonialSlide';
export default TestimonialSlide;